import { h1 } from "@/styles/typography";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const SubHeroContainer = styled.div`
  background-size: cover;
  background-position: center;
  position: relative;
`;

const BackgroundImage = styled(GatsbyImage)`
  width: 100%;
  height: 100%;
  position: absolute;
  object-fit: cover;
  top: 0;
  left: 0;
  z-index: -1;
`;

const S = {
  SubHeroContainer,
  BackgroundImage
};

export default S;
